export default __webpack_public_path__ + "static/media/06.c0d08a0f.jpg";